var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionsStarts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFF6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 8.125C10.4453 8.125 10.617 8.25449 10.6707 8.44231L11.145 10.1026C11.3527 10.8293 11.9207 11.3973 12.6474 11.605L14.3077 12.0793C14.4955 12.133 14.625 12.3047 14.625 12.5C14.625 12.6953 14.4955 12.867 14.3077 12.9207L12.6474 13.395C11.9207 13.6027 11.3527 14.1707 11.145 14.8974L10.6707 16.5577C10.617 16.7455 10.4453 16.875 10.25 16.875C10.0547 16.875 9.883 16.7455 9.82933 16.5577L9.35497 14.8974C9.14734 14.1707 8.57929 13.6027 7.85259 13.395L6.19231 12.9207C6.00449 12.867 5.875 12.6953 5.875 12.5C5.875 12.3047 6.00449 12.133 6.19231 12.0793L7.85259 11.605C8.57929 11.3973 9.14734 10.8293 9.35497 10.1026L9.82933 8.44231C9.883 8.25449 10.0547 8.125 10.25 8.125Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 6.375C15.7008 6.375 15.8757 6.51163 15.9244 6.70639L16.0754 7.31041C16.2126 7.85903 16.641 8.2874 17.1896 8.42456L17.7936 8.57556C17.9884 8.62425 18.125 8.79925 18.125 9C18.125 9.20075 17.9884 9.37575 17.7936 9.42444L17.1896 9.57544C16.641 9.7126 16.2126 10.141 16.0754 10.6896L15.9244 11.2936C15.8757 11.4884 15.7008 11.625 15.5 11.625C15.2992 11.625 15.1243 11.4884 15.0756 11.2936L14.9246 10.6896C14.7874 10.141 14.359 9.7126 13.8104 9.57544L13.2064 9.42444C13.0116 9.37575 12.875 9.20075 12.875 9C12.875 8.79925 13.0116 8.62425 13.2064 8.57556L13.8104 8.42456C14.359 8.2874 14.7874 7.85903 14.9246 7.31041L15.0756 6.70639C15.1243 6.51163 15.2992 6.375 15.5 6.375Z",
    fill: "#FBA12B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.625 14.25C14.8133 14.25 14.9805 14.3705 15.04 14.5492L15.27 15.2391C15.3571 15.5004 15.5621 15.7054 15.8234 15.7925L16.5133 16.0225C16.692 16.082 16.8125 16.2492 16.8125 16.4375C16.8125 16.6258 16.692 16.793 16.5133 16.8525L15.8234 17.0825C15.5621 17.1696 15.3571 17.3746 15.27 17.6359L15.04 18.3258C14.9805 18.5045 14.8133 18.625 14.625 18.625C14.4367 18.625 14.2695 18.5045 14.21 18.3258L13.98 17.6359C13.8929 17.3746 13.6879 17.1696 13.4266 17.0825L12.7367 16.8525C12.558 16.793 12.4375 16.6258 12.4375 16.4375C12.4375 16.2492 12.558 16.082 12.7367 16.0225L13.4266 15.7925C13.6879 15.7054 13.8929 15.5004 13.98 15.2391L14.21 14.5492C14.2695 14.3705 14.4367 14.25 14.625 14.25Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionsStarts);
export default __webpack_public_path__ + "static/media/questions-starts.f1cc6ab6f77ad5a173259a864ece70ff.svg";
export { ForwardRef as ReactComponent };